import React, {useRef, useState, useEffect} from 'react'
import sidebarlogo from '../../assets/img/sidebarlogo.svg'
import {AddProductSdebar} from './AddProductSdebar'
import {MoverProductSidebar} from './MoverProductSidebar'
import {ActivateSidebar} from './ActivateSidebar'
import {GuadarProductSidebar} from './GuadarProductSidebar'
import {InicioPop} from './InicioPop'
import {InicioPop3} from './InicioPop3'
import {InicioPop2} from './InicioPop2'
import {DeleteProductSidebar} from './DeleteProductSidebar'
import {ExportProductSidebar} from './ExportProductSidebar'
import { useParams } from 'react-router-dom'

export const LegendColumnRight = ({HeightStateRight, secondActive = null, setLegendColumns, legendColumns,
promotion, setIdProductoEliminar, setAccionGuardar, movimientos, setInicioPopStateEliminar,setIdEliminar,
textoValidacion, aprobarMovimiento, validacion, setSimulacionPage,toggleSimulacionPage, simulacionPage,
setDownloadCSV, csvLinkRef, setTypePromotion, typePromotion, setCargaMasiva, setModalProduct, setDataProduct, setChangeColumn
}) => {
	// console.log("PROMOCION DATA PROMOCION!!!!!!!!!!!!!! ");
	// console.log(promotion);
	const [state, setState] = useState(1) // secondActive ? 2 : 1
	const [currentOption, setcurrentOption] = useState(1) // secondActive ? 2 : 1
	const [svg, setSvg] = useState(1)
	const [afterstate, setafterState] = useState(null)
	const [frontBar, setfrontBar] = useState(32)
	const [InicioPopState, setInicioPopState] = useState(null)
	const {idPromocion, estadoPromocion} = useParams()

	const ref = useRef(null)

	const handleDocumentClick = (event) => {
		const container = document.querySelector('.LegendColumnRight');
        if (container && !container.contains(event.target)) {
			actionNormalMenu();
        }
    };

	const actionNormalMenu = () => {
		setfrontBar(32)
		setafterState(null)
		setSvg(1)
		setTimeout(() => {
			setcurrentOption(null)
		}, 200)
		// setcurrentOption(null)
	}

	

	useEffect(() => {
        document.addEventListener('mousedown', handleDocumentClick);
        return () => {
            document.removeEventListener('mousedown', handleDocumentClick);
        };
    }, []);
	
	return (
		<div
			className='LegendColumnRight'
			style={{height: `${HeightStateRight}px`}}
			// ref={ref}
		>
			{InicioPopState === 1 && (
				<InicioPop setInicioPopState={setInicioPopState} setAccionGuardar={setAccionGuardar}
				/>
			)}
			{InicioPopState === 2 && (
				<InicioPop2 setInicioPopState={setInicioPopState} />
			)}
			{InicioPopState === 3 && (
				<InicioPop3 setInicioPopState={setInicioPopState} />
			)}
			<div
				className={`front-bar front-bar-first ${state === 1 && 'bluebar'}  ${
					state === 1 && 'come-out'
				}
				${svg === 2 && 'bluebarno'}`}
				style={{width: `${frontBar}px`}}
				
			>
				{svg === 2 && (
					<svg
						width='32'
						
						onClick={(e) => {
							
							setSimulacionPage(false)
							toggleSimulacionPage(false)
							setfrontBar(32)
							setafterState(null)
							setSvg(1) 
							/*
							if((estadoPromocion === '1' || estadoPromocion === '3') || localStorage.getItem('rol') === 'SUPER ADMIN'){
								setSimulacionPage(false)
								toggleSimulacionPage(false)
								setfrontBar(32)
								setafterState(null)
								setSvg(1)
							}else{
								setSimulacionPage(false)
								toggleSimulacionPage(false)
								// setfrontBar(564)
								// setSvg(2)
								// setafterState(1)
								// setcurrentOption(1)
							} */
						}}
						height='32'
						viewBox='0 0 32 32'
						fill='none'
						xmlns='http://www.w3.org/2000/svg'
					>
						<rect
							x='0.5'
							y='0.5'
							width='31'
							height='31'
							rx='15.5'
							fill='#F0F4FC'
						/>
						<g clipPath='url(#clip0_2_689958)'>
							<mask
								id='mask0_2_689958'
								maskUnits='userSpaceOnUse'
								x='4'
								y='4'
								width='24'
								height='24'
							>
								<rect x='4' y='4' width='24' height='24' fill='#D9D9D9' />
							</mask>
							<g mask='url(#mask0_2_689958)'>
								<path
									d='M10.0001 17.1501C9.68343 17.1501 9.41276 17.0374 9.1881 16.8121C8.96276 16.5874 8.8501 16.3168 8.8501 16.0001C8.8501 15.6834 8.96276 15.4128 9.1881 15.1881C9.41276 14.9628 9.68343 14.8501 10.0001 14.8501H22.0001C22.3168 14.8501 22.5874 14.9628 22.8121 15.1881C23.0374 15.4128 23.1501 15.6834 23.1501 16.0001C23.1501 16.3168 23.0374 16.5874 22.8121 16.8121C22.5874 17.0374 22.3168 17.1501 22.0001 17.1501H10.0001Z'
									fill='#3676F5'
								/>
							</g>
						</g>
						<rect
							x='0.5'
							y='0.5'
							width='31'
							height='31'
							rx='15.5'
							stroke='#3676F5'
						/>
						<defs>
							<clipPath id='clip0_2_689958'>
								<rect
									width='24'
									height='24'
									fill='white'
									transform='translate(4 4)'
								/>
							</clipPath>
						</defs>
					</svg>
				)}
				{svg === 1 && (
					<svg 
						className='show-toolbar'
						onClick={(e) => {
							if((estadoPromocion === '1' || estadoPromocion === '3') || localStorage.getItem('rol') === 'SUPER ADMIN'){
								setSimulacionPage(false)
								toggleSimulacionPage(false)
								setfrontBar(564)
								setSvg(2)
								setafterState(1)
								setcurrentOption(1)
							}else{
								setSimulacionPage(false)
								toggleSimulacionPage(false)
								// setfrontBar(564)
								// setSvg(2)
								// setafterState(1)
								// setcurrentOption(1)
							}
						}}
						
						width='32'
						height='32'
						viewBox='0 0 32 32'
						fill='none'
						xmlns='http://www.w3.org/2000/svg'
					>
						<rect
							x='0.5'
							y='0.5'
							width='31'
							height='31'
							rx='15.5'
							fill='#F0F4FC'
						/>
						<g clipPath='url(#clip0_655_226987)'>
							<mask
								id='mask0_655_226987'
								maskUnits='userSpaceOnUse'
								x='4'
								y='4'
								width='24'
								height='24'
							>
								<rect x='4' y='4' width='24' height='24' fill='#D9D9D9' />
							</mask>
							<g mask='url(#mask0_655_226987)'>
								<path
									d='M16.0001 23.15C15.6834 23.15 15.4128 23.0373 15.1881 22.812C14.9628 22.5873 14.8501 22.3166 14.8501 22V17.15H10.0001C9.68343 17.15 9.41276 17.0373 9.1881 16.812C8.96276 16.5873 8.8501 16.3166 8.8501 16C8.8501 15.6833 8.96276 15.4126 9.1881 15.188C9.41276 14.9626 9.68343 14.85 10.0001 14.85H14.8501V9.99998C14.8501 9.68331 14.9628 9.41231 15.1881 9.18698C15.4128 8.96231 15.6834 8.84998 16.0001 8.84998C16.3168 8.84998 16.5874 8.96231 16.8121 9.18698C17.0374 9.41231 17.1501 9.68331 17.1501 9.99998V14.85H22.0001C22.3168 14.85 22.5874 14.9626 22.8121 15.188C23.0374 15.4126 23.1501 15.6833 23.1501 16C23.1501 16.3166 23.0374 16.5873 22.8121 16.812C22.5874 17.0373 22.3168 17.15 22.0001 17.15H17.1501V22C17.1501 22.3166 17.0374 22.5873 16.8121 22.812C16.5874 23.0373 16.3168 23.15 16.0001 23.15Z'
									fill='#3676F5'
								/>
							</g>
						</g>
						<rect
							x='0.5'
							y='0.5'
							width='31'
							height='31'
							rx='15.5'
							stroke='#3676F5'
						/>
						<defs>
							<clipPath id='clip0_655_226987'>
								<rect
									width='24'
									height='24'
									fill='white'
									transform='translate(4 4)'
								/>
							</clipPath>
						</defs>
					</svg>
				)}
				<div className='tooltip-plus'>
					<p>Haz click aquí para agregar productos</p>
				</div>
				{afterstate === 1 && <AddProductSdebar setLegendColumns={setLegendColumns}
        legendColumns={legendColumns}
        promotion={promotion}
        setIdProductoEliminar={setIdProductoEliminar}
		setInicioPopState={setInicioPopStateEliminar}
		setIdEliminar={setIdEliminar}
		actionNormalMenu={actionNormalMenu}
		setModalProduct={setModalProduct}
		setDataProduct={setDataProduct}
		setChangeColumn={setChangeColumn}
        />}
			</div>
			<div className={`front-bar ${afterstate === 3 && 'come-out'} `}>
				{afterstate === 3 && <MoverProductSidebar movimientos={movimientos} 
				promotion={promotion} setAccionGuardar={setAccionGuardar}
				setafterState={setafterState}
				setSvg={setSvg}
				aprobarMovimiento={aprobarMovimiento}
				textoValidacion={textoValidacion}
				validacion={validacion}
				actionNormalMenu={actionNormalMenu}
				simulacionPage={simulacionPage}
				setSimulacionPage={setSimulacionPage}
				/>}
			</div>
			<div className={`front-bar ${afterstate === 4 && 'come-out'} `}>
				{afterstate === 4 && <ActivateSidebar />}
			</div>
			<div className={`front-bar ${afterstate === 5 && 'come-out'} `}>
				{afterstate === 5 && <GuadarProductSidebar setAccionGuardar={setAccionGuardar}
				setafterState={setafterState}
				setfrontBar={setfrontBar}
				setSvg={setSvg}
				textoValidacion={textoValidacion}
				actionNormalMenu={actionNormalMenu}
				simulacionPage={simulacionPage}
				setSimulacionPage={setSimulacionPage}
								/>}
			</div>
			<div className={`front-bar ${afterstate === 7 && 'come-out'} `}>
				{afterstate === 7 && <ExportProductSidebar 
				actionMenuNormal={actionNormalMenu}
				setDownloadCSV={setDownloadCSV}
				csvLinkRef={csvLinkRef}
				/>}
			</div>
			<div className={`front-bar ${afterstate === 8 && 'come-out'} `}>
				{afterstate === 8 && <DeleteProductSidebar 
				movimientos={movimientos} 
				promotion={promotion}
				actionNormalMenu={actionNormalMenu}
				/>}
			</div>
			<div className='beforebar'>
				<span ref={ref} style={secondActive ? {top: 78} : {}}></span>
				<div className='top-area'>
					<div 
						id={"botonAgregar"}
						className={`icon ${currentOption === 1 && 'active'}`}
						onClick={(e) => {
							
							if(currentOption === 1){
								actionNormalMenu()
								setcurrentOption(null)
							}else{
								if(simulacionPage){
									console.log("okok")
									setfrontBar(32)
									setafterState(null)
									setSvg(1)
									setcurrentOption(null)
									
								}else{
									
									/*
									setSvg(2)
									setcurrentOption(1)
									setafterState(1)
									setfrontBar(564)
									setState(1) */

									if((estadoPromocion === '1' || estadoPromocion === '3') || localStorage.getItem('rol') === 'SUPER ADMIN'){
										setSvg(2)
										setcurrentOption(1)
										setafterState(1)
										setfrontBar(564)
										setState(1)
									}else{
										setSvg(2)
										setcurrentOption(1)
										// setafterState(1)
										// setfrontBar(564)
										setState(1)
									}
								}
								
								// setfrontBar(564)
								
								ref.current.style.top = `24px`
							}
							setSimulacionPage(false)							
						}}
					>
						<div className='tooltip-sidebar'>
							<p>Agregar Productos</p>
						</div>
						<svg
							width='16'
							height='16'
							viewBox='0 0 16 16'
							fill='none'
							xmlns='http://www.w3.org/2000/svg'
						>
							<path
								d='M14.1042 5.5L10.5417 1.95833L11.6667 0.8125C12 0.479167 12.4097 0.3125 12.8958 0.3125C13.382 0.3125 13.7986 0.479167 14.1458 0.8125L15.2292 1.91667C15.5764 2.25 15.7533 2.65278 15.76 3.125C15.7672 3.59722 15.6042 4 15.2708 4.33333L14.1042 5.5ZM1.41668 15.5833C1.15279 15.5833 0.927232 15.4897 0.74001 15.3025C0.552232 15.1147 0.458344 14.8889 0.458344 14.625V12.4167C0.458344 12.2917 0.482788 12.17 0.531677 12.0517C0.58001 11.9339 0.652788 11.8264 0.75001 11.7292L9.33334 3.14583L12.8958 6.70833L4.31251 15.2917C4.21529 15.3889 4.11112 15.4619 4.00001 15.5108C3.8889 15.5592 3.7639 15.5833 3.62501 15.5833H1.41668Z'
								fill='white'
							/>
						</svg>
					</div>

					<div
						className={`icon ${currentOption === 2 && 'active'}`}
						onClick={(e) => {
							setafterState(2)
							setState(null)
							setcurrentOption(2)
							ref.current.style.top = `78px`
							// window.location.pathname = '/simulacion/'+promotion.data_promocion.id
							setSimulacionPage(true)
							toggleSimulacionPage(true)
						}}
					>
						<div className='tooltip-sidebar'>
							<p>Ir a Revisión</p>
						</div>
						<svg
							width='20'
							height='20'
							viewBox='0 0 20 20'
							fill='none'
							xmlns='http://www.w3.org/2000/svg'
						>
							<g clipPath='url(#clip0_640_241607)'>
								<mask
									id='mask0_640_241607'
									maskUnits='userSpaceOnUse'
									x='0'
									y='0'
									width='20'
									height='20'
								>
									<rect width='20' height='20' fill='#D9D9D9' />
								</mask>
								<g mask='url(#mask0_640_241607)'>
									<path
										d='M2.58346 16.75C2.06957 16.75 1.63568 16.5727 1.28179 16.2183C0.927344 15.8644 0.750122 15.4305 0.750122 14.9166C0.750122 14.4166 0.930678 13.9897 1.29179 13.6358C1.6529 13.2814 2.08346 13.1041 2.58346 13.1041H2.82346C2.89957 13.1041 2.97234 13.118 3.04179 13.1458L6.56262 9.6458C6.53484 9.56247 6.52096 9.48247 6.52096 9.4058V9.16664C6.52096 8.66664 6.69818 8.23941 7.05262 7.88497C7.40651 7.53108 7.83346 7.35414 8.33346 7.35414C8.83346 7.35414 9.26068 7.53108 9.61512 7.88497C9.96901 8.23941 10.146 8.66664 10.146 9.16664C10.146 9.22219 10.1321 9.37497 10.1043 9.62497L12.0418 11.5625C12.1251 11.5347 12.2015 11.5208 12.271 11.5208H12.7401C12.8162 11.5208 12.889 11.5347 12.9585 11.5625L15.646 8.87497C15.6182 8.80552 15.6043 8.73247 15.6043 8.6558V8.41664C15.6043 7.91664 15.7815 7.48608 16.136 7.12497C16.4898 6.76386 16.9168 6.5833 17.4168 6.5833C17.9307 6.5833 18.3648 6.76025 18.7193 7.11414C19.0732 7.46858 19.2501 7.90275 19.2501 8.41664C19.2501 8.91664 19.0696 9.34358 18.7085 9.69747C18.3473 10.0519 17.9168 10.2291 17.4168 10.2291H17.1776C17.101 10.2291 17.0279 10.2152 16.9585 10.1875L14.271 12.875C14.2987 12.9444 14.3126 13.0172 14.3126 13.0933V13.3333C14.3126 13.8333 14.1357 14.2605 13.7818 14.615C13.4273 14.9689 13.0001 15.1458 12.5001 15.1458C12.0001 15.1458 11.5732 14.9689 11.2193 14.615C10.8648 14.2605 10.6876 13.8333 10.6876 13.3333V13.0933C10.6876 13.0172 10.7015 12.9375 10.7293 12.8541L8.81262 10.9375C8.72929 10.9652 8.64957 10.9791 8.57346 10.9791H8.33346C8.2779 10.9791 8.12512 10.9652 7.87512 10.9375L4.35429 14.4583C4.38207 14.5416 4.39596 14.618 4.39596 14.6875V14.9166C4.39596 15.4166 4.21901 15.8472 3.86512 16.2083C3.51068 16.5694 3.08346 16.75 2.58346 16.75ZM3.33346 8.43747L2.77096 7.22914L1.56262 6.66664L2.77096 6.10414L3.33346 4.8958L3.89596 6.10414L5.10429 6.66664L3.89596 7.22914L3.33346 8.43747ZM12.5001 7.68747L11.646 5.85414L9.81262 4.99997L11.646 4.1458L12.5001 2.31247L13.3543 4.1458L15.1876 4.99997L13.3543 5.85414L12.5001 7.68747Z'
										fill='#3676F5'
									/>
								</g>
							</g>
							<defs>
								<clipPath id='clip0_640_241607'>
									<rect width='20' height='20' fill='white' />
								</clipPath>
							</defs>
						</svg>
					</div>
					<div id={"botonMover"}
						className={`icon ${currentOption === 3 ? 'active' : ''}`}
						onClick={(e) => {
							if(estadoPromocion !== '5' && estadoPromocion !== '7' && estadoPromocion !== '9'){
								if(currentOption === 3){
									actionNormalMenu()
									setcurrentOption(null)
								}else{
									setafterState(3)
									setcurrentOption(3)
									setState(3)
									ref.current.style.top = `134px`
								}
							}

						}}
					>
						<div className='tooltip-sidebar'>
							<p>Mover</p>
						</div>
						<svg
							width='20'
							height='20'
							viewBox='0 0 20 20'
							fill='none'
							xmlns='http://www.w3.org/2000/svg'
						>
							<g clipPath='url(#clip0_640_241621)'>
								<mask
									id='mask0_640_241621'
									maskUnits='userSpaceOnUse'
									x='0'
									y='0'
									width='20'
									height='20'
								>
									<rect width='20' height='20' fill='#D9D9D9' />
								</mask>
								<g mask='url(#mask0_640_241621)'>
									<path
										d='M13.6458 11.1458C13.4653 10.9653 13.375 10.7431 13.375 10.4792C13.375 10.2153 13.4653 9.99306 13.6458 9.8125L15.0208 8.45833H10.1458C9.88196 8.45833 9.6564 8.36444 9.46918 8.17667C9.2814 7.98944 9.18751 7.76389 9.18751 7.5C9.18751 7.23611 9.2814 7.01028 9.46918 6.8225C9.6564 6.63528 9.88196 6.54167 10.1458 6.54167H15.0208L13.6458 5.1875C13.4653 5.00694 13.375 4.78111 13.375 4.51C13.375 4.23944 13.4653 4.01389 13.6458 3.83333C13.8264 3.65278 14.0486 3.5625 14.3125 3.5625C14.5764 3.5625 14.7986 3.65278 14.9792 3.83333L17.9792 6.83333C18.0625 6.93056 18.125 7.03472 18.1667 7.14583C18.2083 7.25694 18.2292 7.375 18.2292 7.5C18.2292 7.625 18.2083 7.74306 18.1667 7.85417C18.125 7.96528 18.0625 8.06944 17.9792 8.16667L14.9792 11.1667C14.7986 11.3472 14.5764 11.4306 14.3125 11.4167C14.0486 11.4028 13.8264 11.3125 13.6458 11.1458ZM5.02084 16.1667L2.02084 13.1667C1.93751 13.0694 1.87501 12.9653 1.83334 12.8542C1.79168 12.7431 1.77084 12.625 1.77084 12.5C1.77084 12.375 1.79168 12.2569 1.83334 12.1458C1.87501 12.0347 1.93751 11.9306 2.02084 11.8333L5.02084 8.83333C5.2014 8.65278 5.42362 8.5625 5.68751 8.5625C5.9514 8.5625 6.17362 8.65278 6.35418 8.83333C6.53473 9.01389 6.62501 9.23944 6.62501 9.51C6.62501 9.78111 6.53473 10.0069 6.35418 10.1875L4.97918 11.5417H9.85418C10.1181 11.5417 10.3439 11.6356 10.5317 11.8233C10.7189 12.0106 10.8125 12.2361 10.8125 12.5C10.8125 12.7639 10.7189 12.9894 10.5317 13.1767C10.3439 13.3644 10.1181 13.4583 9.85418 13.4583H4.97918L6.35418 14.8125C6.53473 14.9931 6.62501 15.2153 6.62501 15.4792C6.62501 15.7431 6.53473 15.9653 6.35418 16.1458C6.17362 16.3264 5.9514 16.42 5.68751 16.4267C5.42362 16.4339 5.2014 16.3472 5.02084 16.1667Z'
										fill='#3676F5'
									/>
								</g>
							</g>
							<defs>
								<clipPath id='clip0_640_241621'>
									<rect width='20' height='20' fill='white' />
								</clipPath>
							</defs>
						</svg>
					</div>
					<div
						className={`icon ${currentOption === 2 && ''}`}
						onClick={(e) => {
							// setafterState(2)
							// setState(null)
							// setcurrentOption(2)
							ref.current.style.top = `190px`
							// window.location.pathname = '/simulacion/'+promotion.data_promocion.id
							// setSimulacionPage(true)
							// toggleSimulacionPage(true)
							if(typePromotion === "SELL-IN"){
								setTypePromotion("SELL-OUT")
							}else{
								setTypePromotion("SELL-IN")
							}
						}}
						style={{color: "#3676f5"}}
					>
						<div className='tooltip-sidebar'>
							<p>Cambiar Tipo de Promoción</p>
						</div>
						{typePromotion === "SELL-IN" ? "SO":"SI"}
					</div>

					
					
					<div
						className={`icon ${currentOption === 112 && 'active'}`}
						onClick={(e) => {
							// setafterState(2)
							// setState(null)
							setcurrentOption(112)
							ref.current.style.top = `245px`
							// window.location.pathname = '/simulacion/'+promotion.data_promocion.id
							// setSimulacionPage(true)
							// toggleSimulacionPage(true)
							setCargaMasiva(true)
						}}
					>
						<div className='tooltip-sidebar'>
							<p>Carga Masiva</p>
						</div>
						<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" stroke="#3676f5" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className="feather feather-upload">
							<path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" fill="none" />
							<polyline points="17 8 12 3 7 8" fill="none" />
							<line x1="12" y1="3" x2="12" y2="10" fill="none" />
						</svg>
					</div>

					
					

				</div>
				<div className='middle-area'>
				{ /*
					<div
						className={`icon ${currentOption === 4 && 'active'}`}
						onClick={(e) => {
							setafterState(4)

							setcurrentOption(4)
							setState(4)
							ref.current.style.top = `320px`
						}}
					>
						<div className='tooltip-sidebar'>
							<p>Actividad</p>
						</div>
						<svg
							width='20'
							height='20'
							viewBox='0 0 20 20'
							fill='none'
							xmlns='http://www.w3.org/2000/svg'
						>
							<g clipPath='url(#clip0_655_229416)'>
								<mask
									id='mask0_655_229416'
									maskUnits='userSpaceOnUse'
									x='0'
									y='0'
									width='20'
									height='20'
								>
									<rect width='20' height='20' fill='#D9D9D9' />
								</mask>
								<g mask='url(#mask0_655_229416)'>
									<path
										d='M5.41667 13.5208C6.06944 13.5208 6.705 13.5938 7.32333 13.74C7.94111 13.8855 8.55556 14.1041 9.16667 14.3958V6.18746C8.59722 5.85413 7.99306 5.60413 7.35417 5.43746C6.71528 5.27079 6.06944 5.18746 5.41667 5.18746C4.91667 5.18746 4.42028 5.23607 3.9275 5.33329C3.43417 5.43051 2.95833 5.57635 2.5 5.77079V14.0208C2.98611 13.8541 3.46889 13.7291 3.94833 13.6458C4.42722 13.5625 4.91667 13.5208 5.41667 13.5208ZM10.8333 14.3958C11.4444 14.1041 12.0592 13.8855 12.6775 13.74C13.2953 13.5938 13.9306 13.5208 14.5833 13.5208C15.0833 13.5208 15.5731 13.5625 16.0525 13.6458C16.5314 13.7291 17.0139 13.8541 17.5 14.0208V5.77079C17.0417 5.57635 16.5661 5.43051 16.0733 5.33329C15.58 5.23607 15.0833 5.18746 14.5833 5.18746C13.9306 5.18746 13.2847 5.27079 12.6458 5.43746C12.0069 5.60413 11.4028 5.85413 10.8333 6.18746V14.3958ZM10.0208 16.5833C9.8125 16.5833 9.61806 16.5588 9.4375 16.51C9.25694 16.4616 9.09028 16.3958 8.9375 16.3125C8.39583 15.993 7.83 15.75 7.24 15.5833C6.64944 15.4166 6.04167 15.3333 5.41667 15.3333C4.84722 15.3333 4.28472 15.4097 3.72917 15.5625C3.17361 15.7152 2.64583 15.9305 2.14583 16.2083C1.8125 16.375 1.48611 16.3647 1.16667 16.1775C0.847222 15.9897 0.6875 15.7083 0.6875 15.3333V5.31246C0.6875 5.10413 0.732778 4.91329 0.823333 4.73996C0.913333 4.56607 1.05556 4.43051 1.25 4.33329C1.88889 4.01385 2.55917 3.77079 3.26083 3.60413C3.96194 3.43746 4.67361 3.35413 5.39583 3.35413C6.21528 3.35413 7.01056 3.45829 7.78167 3.66663C8.55222 3.87496 9.29167 4.1944 10 4.62496C10.7083 4.20829 11.4481 3.89218 12.2192 3.67663C12.9897 3.46163 13.7847 3.35413 14.6042 3.35413C15.3264 3.35413 16.0381 3.43746 16.7392 3.60413C17.4408 3.77079 18.1111 4.01385 18.75 4.33329C18.9444 4.43051 19.0869 4.56607 19.1775 4.73996C19.2675 4.91329 19.3125 5.10413 19.3125 5.31246V15.4166C19.3125 15.7777 19.1564 16.045 18.8442 16.2183C18.5314 16.3922 18.2014 16.3888 17.8542 16.2083C17.3542 15.9305 16.8264 15.7152 16.2708 15.5625C15.7153 15.4097 15.1528 15.3333 14.5833 15.3333C13.9583 15.3333 13.3542 15.4166 12.7708 15.5833C12.1875 15.75 11.6319 15.993 11.1042 16.3125C10.9375 16.3958 10.7639 16.4616 10.5833 16.51C10.4028 16.5588 10.2153 16.5833 10.0208 16.5833Z'
										fill='#3676F5'
									/>
								</g>
							</g>
							<defs>
								<clipPath id='clip0_655_229416'>
									<rect width='20' height='20' fill='white' />
								</clipPath>
							</defs>
						</svg>
					</div>
					*/ }
					<div
						className={`icon ${currentOption === 5 && 'active'}`}
						onClick={(e) => {
								
								if(currentOption === 5){
									actionNormalMenu()
									setcurrentOption(null)
								}else{
									// Ver opción después de bloquear de acuerdo a ciertos estados y tipos de usuarios
									setfrontBar(32)
									setafterState(null)
									setSvg(1)
									setafterState(5)
									setcurrentOption(5)
									setState(5)
								}
							

							ref.current.style.top = `435px` // 375 px
						}}
					>
						<div className='tooltip-sidebar'>
							<p>Guardar</p>
						</div>
						<svg
							width='20'
							height='20'
							viewBox='0 0 20 20'
							fill='none'
							xmlns='http://www.w3.org/2000/svg'
						>
							<g clipPath='url(#clip0_655_229430)'>
								<mask
									id='mask0_655_229430'
									maskUnits='userSpaceOnUse'
									x='0'
									y='0'
									width='20'
									height='20'
								>
									<rect width='20' height='20' fill='#D9D9D9' />
								</mask>
								<g mask='url(#mask0_655_229430)'>
									<path
										d='M4.2286 17.6666C3.70082 17.6666 3.25304 17.4827 2.88526 17.1149C2.51693 16.7466 2.33276 16.2985 2.33276 15.7708V4.22909C2.33276 3.70131 2.51693 3.25325 2.88526 2.88492C3.25304 2.51714 3.70082 2.33325 4.2286 2.33325H13.4578C13.7078 2.33325 13.9475 2.38186 14.1769 2.47909C14.4058 2.57631 14.6105 2.70825 14.7911 2.87492L17.1244 5.20825C17.2911 5.38881 17.423 5.59353 17.5203 5.82242C17.6175 6.05186 17.6661 6.29159 17.6661 6.54159V15.7708C17.6661 16.2985 17.4822 16.7466 17.1144 17.1149C16.7461 17.4827 16.298 17.6666 15.7703 17.6666H4.2286ZM15.7703 6.56242L13.4369 4.22909H4.2286V15.7708H15.7703V6.56242ZM9.99943 14.9374C10.6939 14.9374 11.2842 14.6944 11.7703 14.2083C12.2564 13.7221 12.4994 13.1319 12.4994 12.4374C12.4994 11.743 12.2564 11.1527 11.7703 10.6666C11.2842 10.1805 10.6939 9.93742 9.99943 9.93742C9.30499 9.93742 8.71471 10.1805 8.2286 10.6666C7.74249 11.1527 7.49943 11.743 7.49943 12.4374C7.49943 13.1319 7.74249 13.7221 8.2286 14.2083C8.71471 14.6944 9.30499 14.9374 9.99943 14.9374ZM5.99943 8.39575H11.6036C11.8814 8.39575 12.1105 8.30547 12.2911 8.12492C12.4717 7.94436 12.5619 7.7152 12.5619 7.43742V5.99992C12.5619 5.73603 12.4717 5.51381 12.2911 5.33325C12.1105 5.1527 11.8814 5.06242 11.6036 5.06242H5.99943C5.73554 5.06242 5.51332 5.1527 5.33276 5.33325C5.15221 5.51381 5.06193 5.73603 5.06193 5.99992V7.43742C5.06193 7.7152 5.15221 7.94436 5.33276 8.12492C5.51332 8.30547 5.73554 8.39575 5.99943 8.39575Z'
										fill='#3676F5'
									/>
								</g>
							</g>
							<defs>
								<clipPath id='clip0_655_229430'>
									<rect width='20' height='20' fill='white' />
								</clipPath>
							</defs>
						</svg>
					</div>

					<div
						className={`icon ${currentOption === 6 && 'active'}`}
						onClick={(e) => {
							
							setfrontBar(32)
							setafterState(6)

							setcurrentOption(6)
							setState(6)
							setInicioPopState(1)
							ref.current.style.top = `485px` // 430
						}}
					>
						<div className='tooltip-sidebar'>
							<p>Ir al Inicio</p>
						</div>
						<svg
							width='20'
							height='20'
							viewBox='0 0 20 20'
							fill='none'
							xmlns='http://www.w3.org/2000/svg'
						>
							<g clipPath='url(#clip0_655_229444)'>
								<mask
									id='mask0_655_229444'
									maskUnits='userSpaceOnUse'
									x='0'
									y='0'
									width='20'
									height='20'
								>
									<rect width='20' height='20' fill='#D9D9D9' />
								</mask>
								<g mask='url(#mask0_655_229444)'>
									<path
										d='M5.06249 15.7708H7.37499V10.7083H12.625V15.7708H14.9375V8.35415L9.99999 4.66665L5.06249 8.35415V15.7708ZM5.06249 17.6666C4.53471 17.6666 4.08693 17.4828 3.71916 17.115C3.35082 16.7466 3.16666 16.2986 3.16666 15.7708V8.35415C3.16666 8.06248 3.23277 7.78109 3.36499 7.50998C3.49666 7.23942 3.68055 7.02081 3.91666 6.85415L8.85416 3.14581C9.03471 3.02081 9.21888 2.92692 9.40666 2.86415C9.59388 2.80192 9.79166 2.77081 9.99999 2.77081C10.2083 2.77081 10.4064 2.80192 10.5942 2.86415C10.7814 2.92692 10.9653 3.02081 11.1458 3.14581L16.0833 6.85415C16.3194 7.02081 16.5036 7.23942 16.6358 7.50998C16.7675 7.78109 16.8333 8.06248 16.8333 8.35415V15.7708C16.8333 16.2986 16.6494 16.7466 16.2817 17.115C15.9133 17.4828 15.4653 17.6666 14.9375 17.6666H10.7917V12.5416H9.20832V17.6666H5.06249Z'
										fill='#3676F5'
									/>
								</g>
							</g>
							<defs>
								<clipPath id='clip0_655_229444'>
									<rect width='20' height='20' fill='white' />
								</clipPath>
							</defs>
						</svg>
					</div>
					
					<div
						className={`icon ${currentOption === 7 && 'active'}`}
						onClick={(e) => {
							setafterState(7)
							setcurrentOption(7)
							setState(7)
							ref.current.style.top = `540px`
						}}
					>
						<div className='tooltip-sidebar'>
							<p>Exportar</p>
						</div>
						<svg
							width='20'
							height='20'
							viewBox='0 0 20 20'
							fill='none'
							xmlns='http://www.w3.org/2000/svg'
						>
							<g clipPath='url(#clip0_655_229458)'>
								<mask
									id='mask0_655_229458'
									maskUnits='userSpaceOnUse'
									x='0'
									y='0'
									width='20'
									height='20'
								>
									<rect width='20' height='20' fill='#D9D9D9' />
								</mask>
								<g mask='url(#mask0_655_229458)'>
									<path
										 d='M9.99902 12.7917C9.87402 12.7917 9.75597 12.7708 9.64486 12.7292C9.53375 12.6875 9.42958 12.6181 9.33236 12.5208L6.26986 9.45833C6.0893 9.27778 5.99902 9.05556 5.99902 8.79167C5.99902 8.52778 6.0893 8.30556 6.26986 8.125C6.43652 7.95833 6.65513 7.87167 6.92569 7.865C7.1968 7.85778 7.42263 7.9375 7.60319 8.10417L9.04069 9.5625V3.8125C9.04069 3.54861 9.13458 3.32639 9.32236 3.14583C9.50958 2.96528 9.73513 2.875 9.99902 2.875C10.2629 2.875 10.4885 2.96528 10.6757 3.14583C10.8635 3.32639 10.9574 3.54861 10.9574 3.8125V9.5625L12.3949 8.10417C12.5754 7.9375 12.8012 7.85778 13.0724 7.865C13.3429 7.87167 13.5615 7.95833 13.7282 8.125C13.9087 8.30556 13.999 8.52778 13.999 8.79167C13.999 9.05556 13.9087 9.27778 13.7282 9.45833L10.6657 12.5208C10.5685 12.6181 10.4643 12.6875 10.3532 12.7292C10.2421 12.7708 10.124 12.7917 9.99902 12.7917ZM4.89486 16.9792C4.36708 16.9792 3.9193 16.795 3.55152 16.4267C3.18319 16.0589 2.99902 15.6111 2.99902 15.0833V13.2292C2.99902 12.9653 3.09291 12.7431 3.28069 12.5625C3.46791 12.3819 3.69347 12.2917 3.95736 12.2917C4.22125 12.2917 4.44347 12.3819 4.62402 12.5625C4.80458 12.7431 4.89486 12.9653 4.89486 13.2292V15.0833H15.0824V13.2292C15.0824 12.9653 15.1762 12.7431 15.364 12.5625C15.5512 12.3819 15.7768 12.2917 16.0407 12.2917C16.3046 12.2917 16.5268 12.3819 16.7074 12.5625C16.8879 12.7431 16.9782 12.9653 16.9782 13.2292V15.0833C16.9782 15.6111 16.794 16.0589 16.4257 16.4267C16.0579 16.795 15.6101 16.9792 15.0824 16.9792H4.89486Z'
									/>
								</g>
							</g>
							<defs>
								<clipPath id='clip0_655_229458'>
									<rect width='20' height='20' fill='white' />
								</clipPath>
							</defs>
						</svg>
					</div>
					<div
						className={`icon delete ${currentOption === 8 && 'active'}`}
						onClick={(e) => {
							
							if(currentOption === 8){
								actionNormalMenu()
								setcurrentOption(null)
							}else{
							setafterState(8)
							setcurrentOption(8)
							setState(8)
							ref.current.style.top = `590px` // 535
							}
						}}
					>
						<div className='tooltip-sidebar danger'>
							<p>Descartar</p>
						</div>
						<svg
							width='20'
							height='20'
							viewBox='0 0 20 20'
							fill='none'
							xmlns='http://www.w3.org/2000/svg'
						>
							<g clipPath='url(#clip0_655_229472)'>
								<mask
									id='mask0_655_229472'
									maskUnits='userSpaceOnUse'
									x='0'
									y='0'
									width='20'
									height='20'
								>
									<rect width='20' height='20' fill='#D9D9D9' />
								</mask>
								<g mask='url(#mask0_655_229472)'>
									<path
										d='M5.77096 17.6666C5.25707 17.6666 4.81262 17.4828 4.43762 17.115C4.06262 16.7466 3.87512 16.2986 3.87512 15.7708V5.06248C3.61123 5.06248 3.38901 4.96859 3.20846 4.78081C3.0279 4.59359 2.93762 4.36804 2.93762 4.10415C2.93762 3.84026 3.0279 3.61804 3.20846 3.43748C3.38901 3.25692 3.61123 3.16665 3.87512 3.16665H7.39596C7.39596 2.88887 7.48623 2.6597 7.66679 2.47915C7.84734 2.29859 8.06957 2.20831 8.33346 2.20831H11.6668C11.9307 2.20831 12.1529 2.29859 12.3335 2.47915C12.514 2.6597 12.6043 2.88887 12.6043 3.16665H16.1251C16.389 3.16665 16.6112 3.25692 16.7918 3.43748C16.9723 3.61804 17.0626 3.84026 17.0626 4.10415C17.0626 4.36804 16.9723 4.59359 16.7918 4.78081C16.6112 4.96859 16.389 5.06248 16.1251 5.06248V15.7708C16.1251 16.2986 15.9376 16.7466 15.5626 17.115C15.1876 17.4828 14.7432 17.6666 14.2293 17.6666H5.77096ZM5.77096 5.06248V15.7708H14.2293V5.06248H5.77096ZM7.41679 13.2708C7.41679 13.5208 7.50012 13.7328 7.66679 13.9066C7.83346 14.08 8.04179 14.1666 8.29179 14.1666C8.54179 14.1666 8.75373 14.08 8.92762 13.9066C9.10096 13.7328 9.18762 13.5208 9.18762 13.2708V7.56248C9.18762 7.31248 9.10096 7.10054 8.92762 6.92665C8.75373 6.75331 8.54179 6.66665 8.29179 6.66665C8.04179 6.66665 7.83346 6.75331 7.66679 6.92665C7.50012 7.10054 7.41679 7.31248 7.41679 7.56248V13.2708ZM10.8126 13.2708C10.8126 13.5208 10.8996 13.7328 11.0735 13.9066C11.2468 14.08 11.4585 14.1666 11.7085 14.1666C11.9585 14.1666 12.1668 14.08 12.3335 13.9066C12.5001 13.7328 12.5835 13.5208 12.5835 13.2708V7.56248C12.5835 7.31248 12.5001 7.10054 12.3335 6.92665C12.1668 6.75331 11.9585 6.66665 11.7085 6.66665C11.4585 6.66665 11.2468 6.75331 11.0735 6.92665C10.8996 7.10054 10.8126 7.31248 10.8126 7.56248V13.2708Z'
										fill='#FF5334'
									/>
								</g>
							</g>
							<defs>
								<clipPath id='clip0_655_229472'>
									<rect width='20' height='20' fill='white' />
								</clipPath>
							</defs>
						</svg>
					</div>
				</div>
				<img src={sidebarlogo} className='sidebarlogo' alt='' />
			</div>
		</div>
	)
}
